import { render, staticRenderFns } from "./merchandising.vue?vue&type=template&id=2c0a8b42&scoped=true"
import script from "./merchandising.vue?vue&type=script&lang=js"
export * from "./merchandising.vue?vue&type=script&lang=js"
import style0 from "./merchandising.vue?vue&type=style&index=0&id=2c0a8b42&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c0a8b42",
  null
  
)

export default component.exports